import type { Distance, Point } from "@pdfking/math"
import { Subtract } from "@pdfking/math"

import type { FolderDie, FolderPath } from "#public"

/** A die turned over left to right: for a template drawn the other way round
 * to its preview. */
export const FolderMirror = (die: FolderDie): FolderDie => {
  const flip = ({ x, y }: Point<Distance>) => ({ x: Subtract(die.width, x), y })
  const paths = (drawn: FolderPath[]) =>
    drawn.map(({ points, closed }) => ({
      closed,
      points: points.map(point => ({
        ...point,
        ...flip(point),
        before: flip(point.before),
        after: flip(point.after),
      })),
    }))
  return { ...die, cut: paths(die.cut), fold: paths(die.fold) }
}
